import { isPlatformBrowser } from '@angular/common';
import { Component, Input, PLATFORM_ID, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DtcSearchService } from 'src/app/services/feature/dtcSearch/dtc-search.service';

@Component({
  selector: 'app-dtc-search-list',
  templateUrl: './dtc-search-list.component.html',
  styleUrl: './dtc-search-list.component.scss',
  standalone: false
})
export class DtcSearchListComponent {
  @Input('product') product: any;
  @Input() searchQuery: any;

  private router = inject(Router);
  private dtcService = inject(DtcSearchService);
  private platformId = inject(PLATFORM_ID);

  /** Per-tab key; do not use localStorage (shared across tabs) */
  private readonly SESSION_KEY = 'dtc:last';
  /** Auto-expire the record (ms). Tune as needed. */
  private readonly TTL_MS = 2 * 60 * 1000; // 2 minutes

  /** One-click entry point. Always store, then navigate. */
  onTroubleshootClick(prod: any) {
    // 1) Short-lived record in sessionStorage (per-tab)
    if (isPlatformBrowser(this.platformId)) {
      const record = { payload: prod, exp: Date.now() + this.TTL_MS };
      sessionStorage.setItem(this.SESSION_KEY, JSON.stringify(record));
    }

    // 2) Also emit for same-tab navigations (optional — not relied upon)
    this.dtcService.troubleShootData$.next(prod);

    // 3) Programmatic navigation (prevents races that sometimes happen with <a [routerLink]>)
    this.router.navigate(['/troubleShootingSteps'], {
      // Best-effort fast path: router state (works in new tab too)
      state: { dtcData: prod },
    });
  }
}
